<template>
  <v-ons-page class="l-content l-keyMoment">
    <custom-toolbar backLabel="">{{ $t("Mes moments-clés") }}</custom-toolbar>

    <div class="container">
      <div class="timeLine">

        <div v-for="(key_moment, index) in key_moments"
          :key="index" class="moment"
          :class="[key_moment.sav_fk_taskStatus == 3 ? 'checked' : '', key_moment.sav_date == today_label ? 'today' : '']"
        >
          <div v-if="key_moment.sav_date != today_label" class="infos">
            <div class="picto">
              <i :class="[key_moment.sav_fk_taskStatus == 3 ? 'fas fa-check' : 'far fa-calendar-check', key_moment.sav_date == null ? 'fas fa-times' : '']"></i>
            </div>
            <div class="dateHour">
              {{ key_moment.sav_date !== null ? moment(key_moment.sav_date).format('DD/MM/YYYY') : $t('Indéterminée') }}
              <br>
              {{ key_moment.sav_hourFrom }}
            </div>
          </div>

          <div v-if="key_moment.sav_date == today_label" class="infos">
            <div class="picto">
              <i class="far fa-calendar-check"></i>
            </div>
            <div class="dateHour">
              {{ $t(today_label) }}
            </div>
          </div>

          <div v-if="key_moment.sav_date != today_label" class="descriptionInfo">
            <div class="description">
              {{ $t(key_moment.sav_name) }}
            </div>
          </div>
        </div>

      </div>
    </div>
  </v-ons-page>
</template>

<script>
import moment from 'moment'

export default {
  data() {
    return {
      user: loggedIn,
      key_moments: [],
      moment: moment,
      today_label: "Aujourd'hui"
    };
  },
  created() {
    let self = this;

    axios
      .get('/users/key-moments', {
        params: {
          'x-secundo-auth': self.user.token,
          'prospect_id': self.user.pro_id,
        }
      })
      .then(response => {
        let results = response.data;
        let now = moment().format();

        var today_item = {
          sav_name: null,
          sav_date: this.today_label,
          sav_hourFrom: null,
        };
        var key_moments = [];

        for(let i = 0; i < results.length; i++) {
          if(results[i].sav_date === null || moment(results[i].sav_date).format() > now) {
            if(key_moments.indexOf(today_item) == '-1') {
              key_moments.push(today_item);
            }
          }
          key_moments.push(results[i]);
        }

        if(key_moments.indexOf(today_item) == '-1') {
          key_moments.push(today_item);
        }

        self.key_moments = key_moments;
      });
  },
};
</script>


// WEBPACK FOOTER //
// KeyMoments.vue?10e68dc0